module.exports = __webpack_public_path__ + "img/2i.30f32f6f.png";